import { DataBean } from "../DataBean";

export class EmployeeFactorsConsolidated extends DataBean {


    public async getEmployeeFactorsConsolidated(tableName:any,year:any,accountID:any,valueType:any,fortnightType:any,factorName:any,idAppointment:any,idEntailment:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getEmployeeFactorsConsolidated_String_Number_Number_Number_Number_String_Number_Number_Number_Number", [tableName,year,accountID,valueType,fortnightType,factorName,idAppointment,idEntailment,page,recordsPerPage]);
    }
   

    

 
}